import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class AmbulatoryCareRoomStatus extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("UI.AmbulatoryCareRoomStatus.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    getRoomStatus(status, appointmentDetails) {
        const { errorMessage } = this.props;

        if (errorMessage) {
            return {
                class: "video-error",
                message: errorMessage,
                icon: "icon-error"
            };
        }
        if (appointmentDetails && appointmentDetails.patientInRoom) {
            return {
                class: "in-room",
                message: appointmentDetails.patientName + " is in the room",
                icon: ""
            };
        }
        switch (status) {
            case "room empty":
                return {
                    class: "room-empty",
                    message: "Video will appear here",
                    icon: ""
                };
            case "patient in room":
                return {
                    class: "in-room",
                    message: "Patient is in the room",
                    icon: ""
                };
            case "video error":
                return {
                    class: "video-error",
                    message: this.props.videoErrorMsg,
                    icon: "icon-error"
                };
            default:
                return {
                    class: "",
                    message: "Select an appointment",
                    icon: ""
                };
        }
    }

    render() {
        const { status, appointmentDetails } = this.props;
        let roomStatus = this.getRoomStatus(status, appointmentDetails);

        return (
            <div className={"video-frame" + (roomStatus && roomStatus.class ? " " + roomStatus.class : "")}>
                <div className="video-frame__status">
                    <div className="video-status">
                        {roomStatus.icon &&
                        <div className="video-status__icon"><span className={roomStatus.icon} /></div>
                        }
                        <div className="video-status__msg">{roomStatus.message}</div>                       
                    </div>
                    <div className="video-logo">
                        <img src={roomStatus.class === "in-room" ? "/images/bswh_logo.svg" : "/images/bswh_logo_gray.svg"} alt="Baylor Scott & White logo" className="img-fluid" />
                    </div>
                </div>
            </div>
        );
    }

}

export default AmbulatoryCareRoomStatus;